const _selected = (state, action) => ({
  ...state,
  selectedAppointmentTypeProviderAvailability: action.selectedItem,
});

export { _selected };
